export const ar = {
  // Navbar
  nav: {
    foundationSession: "جلسة حجر الأساس",
    testimonials: "آراء العملاء",
    services: "الخدمات",
    blog: "المدونة",
    aboutDr: "عن د. شيماء",
    contact: "تواصل معايا",
    bookSession: "احجز جلسة",
    bookSessionChange: "احجز جلسة التغيير",
    logoName: "د/ شيماء أنور",
    logoTitle: "أستاذ الصحة العامة والطب الوقائي بكلية الطب• استشاري التغذية العلاجية وطب نمط الحياة",
    openMenu: "فتح القائمة",
    closeMenu: "إغلاق القائمة",
    mainNav: "القائمة الرئيسية",
  },

  // Hero
  hero: {
    trustBadge: "حساب موثّق • +٥٠٠ تحول ناجح",
    headlinePre: "خسارة الوزن أصبحت ",
    headlineHighlight: "أسهل",
    headlinePost: " بنظام غذائي صحي يبدأ من عقلك",
    description: "دكتورة تغذية علاجية — د. شيماء أنور. نصمّم لك جدول نظام غذائي صحي يومي متكامل مش مجرد حمية غذائية. انضم لعملائنا في السعودية والإمارات واحصل على نتائج دائمة.",
    spotsLeft: "٣ أماكن متبقية اليوم فقط",
    ctaBook: "احجز جلسة التغيير الآن",
    ctaWhatsApp: "تواصل واتساب مباشر",
    socialProof: "+٥٠٠ عميل",
    socialProofSuffix: " في السعودية والإمارات • ⭐ ٤.٩/٥",
    sectionLabel: "المقدمة الرئيسية",
    playVideo: "تشغيل فيديو د. شيماء أنور",
    heroImageAlt: "دكتورة تغذية علاجية — د. شيماء أنور — نظام غذائي صحي وجدول يومي متكامل",
    whatsAppMessage: "مرحباً د. شيماء، عايز/ة أعرف أكتر عن برامج التغذية العلاجية",
  },

  // Hero Testimonials
  heroTestimonials: {
    sectionLabel: "نتائج العملاء",
    heading: "نتائج حقيقية من عملاء حقيقيين",
    items: [
      { name: "سارة أحمد", role: "مديرة تسويق", quote: "نزلت ١٥ كيلو في ٣ شهور وطاقتي بقت عالية جداً", stat: "-١٥ كجم", statLabel: "في ٣ شهور" },
      { name: "محمد خالد", role: "رائد أعمال", quote: "إنتاجيتي وتركيزي بقوا أحسن من أي وقت", stat: "+٨٠%", statLabel: "زيادة في الطاقة" },
      { name: "نورهان محمود", role: "أم لـ ٣ أطفال", quote: "أخيراً لقيت نظام يشتغل مع العيلة كلها", stat: "-١٢ كجم", statLabel: "بدون حرمان" },
    ],
  },

  // Video Section
  video: {
    tag: "صحتك النفسية والجسدية",
    heading: "توازن حقيقي بين صحتك النفسية والجسدية",
    description: "اشترك في القناة وكون جزء من عيلتنا — نصائح عملية في التغذية العلاجية وطب نمط الحياة",
    playLabel: "تشغيل فيديو د. شيماء أنور",
    thumbnailAlt: "صورة مصغرة لفيديو د. شيماء أنور",
  },

  // Stats
  stats: {
    sectionLabel: "الإحصائيات",
    items: [
      { value: "+٥٠٠", label: "عميل ناجح", description: "حققوا أهدافهم الصحية" },
      { value: "٩٢%", label: "معدل النجاح", description: "نتائج مستدامة بعد سنة" },
      { value: "+١٠", label: "سنوات خبرة", description: "في التغذية العلاجية" },
      { value: "٤.٩/٥", label: "تقييم العملاء", description: "رضا تام عن الخدمة" },
    ],
  },

  // Therapeutic Nutrition
  therapeuticNutrition: {
    tag: "التغذية العلاجية وطب نمط الحياة",
    heading: "ما هي التغذية العلاجية؟",
    description: "التغذية العلاجية هي فرع متخصص من الطب تقدمه دكتورة تغذية علاجية متخصصة في القاهرة، تستخدم الغذاء كأداة علاجية لتصميم خطة تغذية شخصية وجدول نظام غذائي صحي يومي متكامل لعلاج الأمراض المزمنة مثل السكري وتكيس المبايض (PCOS) وأمراض الأمعاء — بدون حمية غذائية مقيّدة أو حرمان.",
    entities: [
      "إدارة السكري وخطط تغذية مخصصة",
      "تكيس المبايض (PCOS) والهرمونات",
      "الأكل العاطفي وعلاقتك بالطعام",
      "تحسين الطاقة وعلاج التعب المزمن",
      "النوم والتوتر وتأثيرهم على الوزن",
      "إنقاص الوزن بدون حرمان أو دايت مقيّد",
    ],
    citation: "، التغذية العلاجية المتخصصة تقلل مضاعفات الأمراض المزمنة بنسبة تصل إلى ٧٠٪.",
    citationPrefix: "وفقاً لـ",
    citationAnd: "و",
    entitiesLabel: "مجالات التغذية العلاجية",
  },

  // Philosophy
  philosophy: {
    tag: "طب نمط الحياة",
    heading: "الدعائم الست للصحة المتكاملة",
    description: "طب نمط الحياة — المعتمد من",
    aclmName: "الكلية الأمريكية لطب نمط الحياة (ACLM)",
    descMiddle: "— بيركز على الست دعائم الأساسية اللي بتأثر على صحتك: التغذية، الحركة، النوم، إدارة الضغوط، العلاقات الداعمة، والتخلص من العادات الضارة. وفقاً لتوصيات",
    whoName: "منظمة الصحة العالمية",
    descEnd: "، تغيير نمط الحياة يمنع أكثر من ٨٠٪ من الأمراض المزمنة.",
    pillars: [
      { title: "التغذية", description: "استراتيجيات تغذية مخصصة على حسب جسمك وحياتك وأهدافك. أنظمة أكل مستدامة ومبنية على العلم." },
      { title: "الحركة", description: "برنامج لياقة وظيفية بيكمّل رحلة صحتك. ابني قوة، حسّن حركتك، وارفع أداءك اليومي." },
      { title: "النوم", description: "تحسين جودة نومك لاستعادة طاقتك وتعزيز صحتك الجسدية والعقلية." },
      { title: "إدارة الضغوط", description: "تقنيات فعّالة للتعامل مع ضغوط الحياة اليومية وتحقيق التوازن النفسي." },
      { title: "العلاقات الداعمة", description: "بناء شبكة دعم اجتماعي قوية تساعدك على الاستمرار في رحلتك الصحية." },
      { title: "التخلص من العادات الضارة", description: "استراتيجيات للتخلي عن السلوكيات المضرة واستبدالها بعادات صحية مستدامة." },
    ],
  },

  // Testimonials
  testimonials: {
    tag: "قصص النجاح",
    heading: "تحولات حقيقية، ناس حقيقية",
    prevLabel: "الشهادة السابقة",
    nextLabel: "الشهادة التالية",
    goToLabel: "اذهب للشهادة",
    items: [
      { name: "سارة أحمد", role: "مديرة تسويق", quote: "الشغل مع الكوتش ده غيّر علاقتي بالأكل تماماً. نزلت ١٥ كيلو وطاقتي بقت عالية جداً. شغل العقلية كان Game changer." },
      { name: "محمد خالد", role: "رائد أعمال تكنولوجيا", quote: "كواحد بيزنس مشغول، كنت محتاج حاجة مستدامة. برنامج النخبة مناسبني جداً. إنتاجيتي وتركيزي بقوا أحسن من أي وقت." },
      { name: "نورهان محمود", role: "أم عاملة لـ ٣ أطفال", quote: "أخيراً لقيت نظام يشتغل مع العيلة كلها. الوصفات لذيذة والدعم مذهل. ده مش دايت - ده نمط حياة." },
      { name: "أحمد عادل", role: "رياضي سابق", quote: "بعد سنين من الدايتات اللي بترجع تاني، أخيراً فهمت جسمي. النظام العلمي ساعدني أرجع أدائي الرياضي وثقتي." },
    ],
  },

  // Author Block
  author: {
    tag: "الطبيبة المعالجة",
    heading: "د. شيماء أنور",
    bio: "أستاذ الصحة العامة بكلية الطب واستشاري التغذية العلاجية وطب نمط الحياة. صاحبة أول برنامج عربي يجمع بين تغيير العقلية والتغذية العلاجية القائمة على الأدلة.",
    imageAlt: "د. شيماء أنور — استشاري التغذية العلاجية وأستاذ الصحة العامة",
    credentials: [
      { title: "أستاذ الصحة العامة", detail: "كلية الطب — جامعة معتمدة" },
      { title: "استشاري التغذية العلاجية", detail: "متخصصة في التغذية العلاجية والأمراض المزمنة" },
      { title: "معتمدة من ACLM", detail: "الكلية الأمريكية لطب نمط الحياة" },
      { title: "باحثة ومحاضرة", detail: "أبحاث منشورة في التغذية العلاجية وطب نمط الحياة" },
    ],
    specializationsTitle: "التخصصات والخبرات",
    specializations: [
      "التغذية العلاجية للأمراض المزمنة",
      "إدارة السكري من النوع الثاني",
      "صحة الأمعاء والميكروبيوم",
      "السمنة ومقاومة الأنسولين",
      "طب نمط الحياة والكوتشينج النفسي",
      "تغذية المرأة والمكملات الغذائية",
    ],
    hashtag: "#وافتكر_دائماً_إنك_مش_لوحدك",
    specializationsLabel: "تخصصات د. شيماء أنور",
  },

  // Foundation Session
  foundation: {
    badge: "الخطوة الأولى الموصى بها",
    heading: "ابدأ رحلتك مع د. شيماء",
    headingHighlight: " بجلسة حجر الأساس",
    subtitle: "٤٠ دقيقة تكتشف فيهم إذا كنت جاهز فعلاً تبدأ رحلة التغيير – فقط بـ",
    price: "٥٠٠ جنيه",
    ctaTop: "ابدأ الآن بجلسة ٥٠٠ جنيه",
    badgeCard: "مناسب لأول جلسة",
    cardTitle: "جلسة حجر الأساس – ٤٠ دقيقة",
    duration: "٤٠ دقيقة",
    priceValue: "٥٠٠",
    priceCurrency: "جنيه",
    priceNote: "استثمار بسيط قبل أي التزام طويل المدى",
    bullets: [
      "نحدد فين واقف دلوقتي والتحديات الحقيقية في حياتك وصحتك",
      "نرسم صورة واضحة للنسخة اللي نفسك توصلها",
      "تعرف إذا كنت فعلاً مستعد لرحلة التغيير الكاملة",
    ],
    note: "هذه الجلسة هي الخطوة الأولى قبل اختيار أي باقة كاملة",
    ctaCard: "احجز جلسة حجر الأساس",
    reassurance: "جلسة سريعة، استثمار بسيط، قبل ما تلتزم بأي باقة",
    detailTitle: "إيه اللي هيحصل في الجلسة؟",
    detailDesc: "الجلسة دي هي \"حجر الأساس\" اللي هنبني عليه كل اللي جاي. في خلال ٤٠ دقيقة، هدفي إني أسمعك بقلب كوتش وعقل طبيبة عشان نحدد:",
    step1Title: "إحنا فين دلوقتي؟",
    step1Desc: "هنحط إيدنا على التحديات الحقيقية اللي معطلة حياتك أو مأثرة على صحتك.",
    step2Title: "هدفنا نوصل لإيه؟",
    step2Desc: "هنرسم صورة واضحة ومحددة للنسخة اللي تتمنى توصلها من نفسك فيما يتعلق بحياتك الصحية والاجتماعية.",
    quoteTitle: "كلمة من القلب قبل ما نبدأ",
    quote1: "وعشان التغيير رحلة محتاجة نَفَس طويل ومجهود متبادل، فالجلسة دي هدفها الأساسي إني أحدد العميل المستعد بجد لتحدي التغيير.",
    quote2: "مش كل الناس بتكون جاهزة في الوقت الحالي لمتطلبات الرحلة دي، وده حقهم تماماً..",
    quote3: "وعشان كدة، أنا بختار العميل اللي عنده عزيمة حقيقية إنه يتغير، عشان أضمن إن وقتنا ومجهودنا مع بعض يوصلوا لنتيجة حقيقية واستثمار ناجح في الوقت والمجهود.",
    hashtag: "#وافتكر_دايما_انك_مش_لوحدك",
    sessionLabel: "جلسة حجر الأساس – ٤٠ دقيقة",
    sessionLabelShort: "جلسة حجر الأساس – ٤٠ دقيقة • ٥٠٠ جنيه",
  },

  // Services
  services: {
    tag: "اختار باقتك",
    heading: "باقات مصممة لنجاحك",
    description: "كل باقة تشمل جدول نظام غذائي صحي يومي متكامل + حمية غذائية مخصصة ١٠٠% لاحتياجاتك. اختار اللي يناسب أهدافك.",
    offerEnds: "العرض ينتهي خلال",
    day: "يوم",
    hour: "ساعة",
    minute: "دقيقة",
    second: "ثانية",
    discount: "🔥 خصم 30% إضافي — لفترة محدودة فقط",
    foundationNote: "💡 يفضل حجز",
    foundationLink: "جلسة حجر الأساس",
    foundationNoteSuffix: " أولاً لتحديد مدى جاهزيتك وأفضل باقة مناسبة لك.",
    mostPopular: "الأكثر شعبية",
    startNow: "ابدأ دلوقتي",
    suggestedStep: "الخطوة المقترحة قبل هذه الباقة:",
    foundationPrice: "جلسة حجر الأساس بـ ٥٠٠ جنيه",
    packages: [
      {
        name: "البداية",
        originalPrice: "٥,٠٠٠ ج.م",
        price: "٣,٥٠٠ ج.م",
        duration: "٤ أسابيع",
        description: "بداية قوية لكسر العادات السيئة وبناء أساس صحي.",
        features: ["تقييم صحي شامل", "خطة وجبات مخصصة", "مكالمة كوتشينج أسبوعية ٣٠ دقيقة", "دعم عبر الإيميل", "مجموعة وصفات صحية"],
      },
      {
        name: "التحول",
        originalPrice: "١٢,٨٥٧ ج.م",
        price: "٩,٠٠٠ ج.م",
        duration: "١٢ أسبوع",
        description: "برنامج شامل لتغيير نمط حياتك ونتايج دائمة.",
        features: ["تحليل أيض متعمق", "بروتوكول تغذية شخصي", "مكالمة كوتشينج أسبوعية ٦٠ دقيقة", "برنامج حركة", "جلسات كوتشينج عقلي", "دعم واتساب أولوية", "متابعة التقدم"],
      },
      {
        name: "النخبة",
        originalPrice: "٣٥,٧١٤ ج.م",
        price: "٢٥,٠٠٠ ج.م",
        duration: "٦ شهور",
        description: "دعم VIP للمديرين التنفيذيين وأصحاب الأداء العالي اللي عايزين صحة مثالية.",
        features: ["كل مميزات التحول", "جلسات ٩٠ دقيقة كل أسبوعين", "تواصل مباشر ٢٤/٧", "مراجعة تحاليل ربع سنوية", "إدارة ضغط العمل", "خطة تغذية للسفر", "إرشاد تغذية العيلة"],
      },
    ],
  },

  // Urgency Banner
  urgency: {
    heading: "الأماكن محدودة هذا الشهر",
    description: "احجز جلسة التغيير بسعر مميز الآن — ٣ أماكن متبقية فقط",
    cta: "احجز جلسة التغيير الآن",
  },

  // FAQ
  faq: {
    tag: "أسئلة شائعة",
    heading: "عندك سؤال؟ عندنا الإجابة",
    items: [
      { question: "ما هي التغذية العلاجية وطب نمط الحياة؟", answer: "التغذية العلاجية وطب نمط الحياة (Lifestyle Medicine) هو نهج طبي شامل يستخدم الغذاء كأداة علاجية مع التركيز على الدعائم الست للصحة: التغذية، الحركة، النوم، إدارة التوتر، العلاقات الداعمة، والتخلص من العادات الضارة. د. شيماء أنور تجمع بين التخصصين لتقديم برنامج تحول صحي متكامل — مش مجرد دايت." },
      { question: "إيه نصيحة التغذية لحالات تكيس المبايض (PCOS)؟", answer: "لحالات تكيس المبايض، د. شيماء تصمم بروتوكول تغذية مضاد للالتهابات يركز على: تقليل مقاومة الأنسولين بأطعمة منخفضة المؤشر الجلايسيمي، زيادة الأوميجا ٣، تحسين مستويات فيتامين D، إدارة هرمونات التوتر، والتخلص من الأطعمة المصنعة والسكريات. كل خطة مخصصة حسب التحاليل الهرمونية والأعراض الفردية." },
      { question: "إزاي أحصل على خطة تغذية شخصية لمريض سكري في مصر؟", answer: "د. شيماء أنور تقدم خطط تغذية شخصية ١٠٠% لمرضى السكري في كل محافظات مصر أونلاين. الخطة تشمل: جدول وجبات صديق لسكر الدم، حساب وتوزيع الكربوهيدرات، بدائل من الأكل المصري، تنسيق بين الأدوية والتغذية، ومتابعة أسبوعية لمستويات الجلوكوز. البداية بجلسة تقييم شاملة لتحاليلك." },
      { question: "إزاي أوقف الأكل العاطفي وأنزل وزني؟", answer: "الأكل العاطفي هو آلية تعامل مع التوتر والقلق والملل. نهج د. شيماء يعالج الأكل العاطفي من خلال: ١) تحديد المحفزات (توتر، وحدة، ملل)، ٢) كوتشينج نفسي لكسر دورة الأكل-الذنب، ٣) بناء بدائل صحية للتعامل مع المشاعر، ٤) تعديلات غذائية تثبّت سكر الدم وتقلل الرغبة الشديدة في الأكل، ٥) إدارة النوم والتوتر لخفض الكورتيزول." },
      { question: "طاقتي بتنزل بعد الغدا — آكل إيه؟", answer: "انخفاض الطاقة بعد الغدا سببه عادة ارتفاع سكر الدم ثم انخفاضه السريع. الحل: وجبات متوازنة (بروتين + دهون صحية + كربوهيدرات معقدة)، توقيت الوجبات الصحيح، التخلص من السكريات المخفية والكربوهيدرات المكررة، إضافة سناكس مثبتة للطاقة، وتحسين الترطيب. لو المشكلة مستمرة، ممكن يكون في مقاومة أنسولين أو نقص حديد أو B12." },
      { question: "النوم والتوتر بيأثروا على وزني — أعمل إيه؟", answer: "العلاقة بين النوم والتوتر والوزن حقيقية وموثقة علمياً. النوم السيء يزيد هرمون الجوع (جريلين) ويقلل هرمون الشبع (لبتين)، والتوتر المزمن يرفع الكورتيزول ويخزن دهون البطن. د. شيماء تعالج ده من خلال: بروتوكولات نوم صحي، تقنيات إدارة التوتر، تعديلات غذائية تدعم النوم (مغنيسيوم، أطعمة غنية بالتريبتوفان)، وتوقيت وجبات يضبط الكورتيزول." },
      { question: "عايز/ة أنزل وزني من غير دايت مقيّد أو حرمان", answer: "فلسفة د. شيماء كلها مبنية على إنقاص الوزن المستدام بدون حرمان: مفيش عد سعرات مهووس، مفيش حذف مجموعات غذائية، مفيش تجويع. بدلاً من كده، بنركز على: فهم إشارات جسمك، بناء علاقة صحية مع الأكل، وجبات ممتعة من أكلك المحلي اللي بتحبه، معالجة الحواجز النفسية لخسارة الوزن، وتغييرات تدريجية في نمط الحياة تدوم للأبد. عملاؤنا نزلوا ١٥ كيلو في ٣ شهور بدون ما يحسوا بالحرمان." },
      { question: "المتابعة بتكون إزاي؟", answer: "مكالمات كوتشينج أسبوعية (٣٠-٩٠ دقيقة حسب الباقة) + دعم واتساب يومي + متابعة تقدمك المستمر مع تعديل الخطة حسب نتائجك. البرنامج أونلاين بالكامل من القاهرة ويناسب عملاء مصر والسعودية والإمارات والكويت." },
      { question: "إيه أسعار الباقات بالعملات الخليجية؟", answer: "باقة البداية ٣,٥٠٠ ج.م (≈٢٦٠ ريال سعودي). باقة التحول ٩,٠٠٠ ج.م (≈٦٧٠ ريال). باقة النخبة ٢٥,٠٠٠ ج.م (≈١,٨٦٠ ريال). الدفع بالجنيه المصري والأسعار تقريبية حسب سعر الصرف." },
    ],
  },

  // Lead Magnet
  leadMagnet: {
    heading: "مجاناً: دليل الـ ٧ أيام للحيوية",
    description: "ابدأ تحولك بنظامي المُثبت. هتوصلك نصايح يومية عملية للتغذية والحركة والعقلية على إيميلك.",
    placeholder: "اكتب إيميلك",
    cta: "احصل على الدليل المجاني",
    processing: "جاري المعالجة...",
    socialLine: "انضم لأكتر من ٥,٠٠٠ شخص في رحلة الحيوية. ممكن تلغي الاشتراك في أي وقت.",
    errorTitle: "إيميل غلط",
    errorDesc: "من فضلك اكتب إيميل صحيح.",
    alreadyTitle: "إيميلك مسجل بالفعل!",
    alreadyDesc: "أنت مسجل عندنا. تابع الإنبوكس بتاعك.",
    successTitle: "أهلاً بيك في الرحلة!",
    successDesc: "هتلاقي دليل الـ ٧ أيام للحيوية في الإنبوكس بتاعك.",
    failTitle: "حصل مشكلة",
    failDesc: "مقدرتش أسجل الإيميل. جرب تاني.",
  },

  // Contact
  contact: {
    tag: "تواصل معايا",
    heading: "مستعد تبدأ تحولك؟",
    description: "سواء عندك أسئلة عن البرامج أو مستعد تاخد أول خطوة، يشرفني أسمع منك. خلينا نشوف إزاي نقدر نشتغل مع بعض.",
    emailLabel: "الإيميل",
    phoneLabel: "الموبايل",
    locationLabel: "المكان",
    locationValue: "القاهرة، مصر (متاح أونلاين)",
    nameLabel: "الاسم الكامل",
    namePlaceholder: "اسمك",
    emailPlaceholder: "email@example.com",
    messageLabel: "الرسالة",
    messagePlaceholder: "قولي عن أهدافك وإزاي أقدر أساعدك...",
    submit: "ابعت الرسالة",
    processing: "جاري المعالجة...",
    errorTitle: "خطأ في البيانات",
    successTitle: "الرسالة اتبعتت!",
    successDesc: "شكراً لتواصلك. هرد عليك خلال ٢٤ ساعة.",
    failTitle: "حصل مشكلة",
    failDesc: "مقدرتش أبعت الرسالة. جرب تاني.",
  },

  // Footer
  footer: {
    copyright: "© {year} حيوية كوتشينج. كل الحقوق محفوظة.",
    madeWithLove: "لصحتك اتعمل بحب",
    trustedSources: "مصادر موثوقة:",
    servicesTitle: "خدماتنا",
    resourcesTitle: "موارد",
    legalTitle: "قانوني",
    services: {
      foundationSession: "جلسة حجر الأساس",
      starter: "البداية",
      transformation: "التحول",
      elite: "النخبة",
    },
    resources: {
      freeGuide: "دليل الحيوية المجاني",
      blog: "المدونة",
      aboutDr: "عن د. شيماء",
      services: "الخدمات",
    },
    legal: {
      privacy: "سياسة الخصوصية",
    },
  },

  // Social Proof Toast
  socialProof: {
    close: "إغلاق",
    suffix: "+٥٠٠ تحول ناجح في السعودية والإمارات",
    items: [
      { name: "سارة م.", location: "الرياض 🇸🇦", text: "نزلت ١٥ كيلو في ٣ شهور" },
      { name: "أحمد ك.", location: "دبي 🇦🇪", text: "تغيرت حياتي بالكامل" },
      { name: "نورة ع.", location: "جدة 🇸🇦", text: "أفضل قرار أخذته لصحتي" },
      { name: "محمد ر.", location: "أبوظبي 🇦🇪", text: "نتائج رائعة من أول شهر" },
      { name: "فاطمة أ.", location: "الدمام 🇸🇦", text: "طاقتي ومزاجي اتحسنوا جداً" },
    ],
  },

  // Exit Intent Popup
  exitPopup: {
    heading: "لحظة! عندك هدية 🎁",
    description: "قبل ما تمشي، حمّل",
    guideName: "دليل الـ ٧ أيام للحيوية",
    descriptionSuffix: " مجاناً — نصائح يومية عملية للتغذية والطاقة.",
    placeholder: "اكتب إيميلك هنا",
    cta: "نزّل الدليل المجاني",
    processing: "جاري المعالجة...",
    trustLine: "🔒 إيميلك في أمان. بدون سبام. إلغاء الاشتراك في أي وقت.",
    noThanks: "لا شكراً، مش محتاج",
    ariaLabel: "عرض خاص قبل ما تمشي",
    close: "إغلاق",
  },

  // Sticky Mobile CTA
  stickyCta: {
    text: "احجز جلسة التغيير الآن",
  },

  // Booking Modal
  booking: {
    chooseDate: "اختر موعدك المفضل",
    chooseTime: "اختر الوقت",
    spotsLeft: "٣ أماكن متبقية اليوم فقط",
    next: "التالي",
    contactInfo: "بيانات التواصل",
    nameLabel: "الاسم",
    namePlaceholder: "اكتب اسمك",
    whatsappLabel: "رقم الواتساب",
    emailLabel: "الإيميل",
    emailNote: "لإرسال تأكيد الحجز على إيميلك",
    confirmNote: "سيتم تأكيد حجزك عبر واتساب فوراً",
    back: "رجوع",
    confirmWhatsApp: "تأكيد الحجز عبر واتساب",
    processing: "جاري المعالجة...",
    successTitle: "تم إرسال طلب الحجز بنجاح!",
    successDesc: "سيتم التواصل معك عبر واتساب لتأكيد الموعد",
    foundationSuccessDesc: "فريق د. شيماء هيتواصل معاك لتأكيد المعاد النهائي خلال أقرب وقت",
    errorTitle: "حدث خطأ",
    errorDesc: "يرجى المحاولة مرة أخرى أو التواصل عبر واتساب",
    nameError: "يرجى إدخال اسم صحيح (حرفين على الأقل)",
    phoneError: "رقم الهاتف يجب أن يكون {n} أرقام",
    emailError: "يرجى إدخال إيميل صحيح",
    foundationLabel: "جلسة حجر الأساس – ٤٠ دقيقة",
    generalLabel: "استشارة تغذية",
    foundationBadge: "جلسة حجر الأساس – ٤٠ دقيقة • ٥٠٠ جنيه",
    whatsAppConfirmMsg: "مرحباً، حجزت جلسة وأريد تأكيد المعاد",
    whatsAppConfirmFoundation: "مرحباً، حجزت جلسة حجر الأساس وأريد تأكيد المعاد",
    days: ["الأحد", "الإثنين", "الثلاثاء", "الأربعاء", "الخميس", "الجمعة", "السبت"],
    months: ["يناير", "فبراير", "مارس", "أبريل", "مايو", "يونيو", "يوليو", "أغسطس", "سبتمبر", "أكتوبر", "نوفمبر", "ديسمبر"],
    successCardTitle: "تم إرسال طلب الحجز!",
    whatsappConfirmBtn: "تأكيد عبر واتساب",
    close: "إغلاق",
  },

  // WhatsApp
  whatsapp: {
    label: "تواصل عبر واتساب",
    message: "مرحباً د. شيماء، عايز/ة أعرف أكتر عن برامج التغذية العلاجية",
  },
} as const;
